import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, vModelText as _vModelText, withKeys as _withKeys, withDirectives as _withDirectives, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createCommentVNode as _createCommentVNode, createBlock as _createBlock, createStaticVNode as _createStaticVNode } from "vue"
import _imports_0 from '../../assets/img/icons/search.svg'
import _imports_1 from '../../assets/img/icons/close.svg'
import _imports_2 from '../../assets/img/icons/tick-circle.svg'


const _hoisted_1 = { class: "main-content bg_gray d-flex flex-column transition overflow-hidden" }
const _hoisted_2 = { class: "row mb-40" }
const _hoisted_3 = { class: "col-12" }
const _hoisted_4 = { class: "form-group" }
const _hoisted_5 = { class: "search-area style-two position-relative w-100" }
const _hoisted_6 = {
  key: 0,
  class: "suggestions-dropdown"
}
const _hoisted_7 = ["onClick"]
const _hoisted_8 = { class: "card border-0 shadow-none rounded-1 mb-30" }
const _hoisted_9 = { class: "card-body p-xl-40" }
const _hoisted_10 = { class: "table-responsive" }
const _hoisted_11 = { class: "table text-nowrap align-middle mb-0" }
const _hoisted_12 = { key: 0 }
const _hoisted_13 = { class: "shadow-none lh-1 fs-14 fw-normal text-paragraph ps-0" }
const _hoisted_14 = { class: "shadow-none lh-1 fs-14 fw-normal text-paragraph" }
const _hoisted_15 = { class: "shadow-none lh-1 fs-14 fw-normal text-paragraph" }
const _hoisted_16 = { class: "shadow-none lh-1 fs-14 fw-normal text-paragraph" }
const _hoisted_17 = { class: "badge badge-success fw-semibold fs-14" }
const _hoisted_18 = { class: "shadow-none lh-1 fs-14 fw-normal text-paragraph" }
const _hoisted_19 = { class: "v-counter style-two" }
const _hoisted_20 = ["onClick"]
const _hoisted_21 = ["onUpdate:modelValue", "max", "onChange"]
const _hoisted_22 = ["onClick"]
const _hoisted_23 = { class: "shadow-none lh-1 fs-14 fw-normal text-paragraph" }
const _hoisted_24 = { class: "shadow-none lh-1 text-end pe-0" }
const _hoisted_25 = { class: "button-group style-two ms-auto d-flex flex-wrap align-items-center" }
const _hoisted_26 = {
  class: "delete-btn",
  "data-bs-toggle": "offcanvas",
  href: "#deletePopup",
  role: "button",
  "aria-controls": "deletePopup"
}
const _hoisted_27 = ["onClick"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_MainHeader = _resolveComponent("MainHeader")!
  const _component_MainSidebar = _resolveComponent("MainSidebar")!
  const _component_BreadcrumbMenu = _resolveComponent("BreadcrumbMenu")!
  const _component_SubmitPurchase = _resolveComponent("SubmitPurchase")!
  const _component_MainFooter = _resolveComponent("MainFooter")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(_component_MainHeader),
    _createVNode(_component_MainSidebar),
    _createElementVNode("div", _hoisted_1, [
      _createVNode(_component_BreadcrumbMenu, { pageTitle: "Create Sales" }),
      _createElementVNode("div", _hoisted_2, [
        _createElementVNode("div", _hoisted_3, [
          _createElementVNode("div", _hoisted_4, [
            _cache[4] || (_cache[4] = _createElementVNode("label", { class: "d-block fs-14 text-black mb-2" }, "Choose Product", -1)),
            _createElementVNode("div", _hoisted_5, [
              _withDirectives(_createElementVNode("input", {
                type: "text",
                placeholder: "Scan / Search product by code",
                class: "w-100 h-55 bg_ash border-0 rounded-1 fs-14 text-black bg-white",
                "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.barcode) = $event)),
                onKeydown: _cache[1] || (_cache[1] = _withKeys(
//@ts-ignore
(...args) => (_ctx.searchProduct && _ctx.searchProduct(...args)), ["enter"]))
              }, null, 544), [
                [_vModelText, _ctx.barcode]
              ]),
              _createElementVNode("button", {
                type: "submit",
                class: "bg-transparent border-0 position-absolute top-0 end-0 h-100 pt-0 py-0 px-2",
                onClick: _cache[2] || (_cache[2] = 
//@ts-ignore
(...args) => (_ctx.searchProduct && _ctx.searchProduct(...args)))
              }, _cache[3] || (_cache[3] = [
                _createElementVNode("img", {
                  src: _imports_0,
                  alt: "Search Icon"
                }, null, -1)
              ])),
              (_ctx.suggestions.length)
                ? (_openBlock(), _createElementBlock("ul", _hoisted_6, [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.suggestions, (product) => {
                      return (_openBlock(), _createElementBlock("li", {
                        key: product.suggestion,
                        onClick: ($event: any) => (_ctx.selectProduct(product))
                      }, _toDisplayString(product.suggestion), 9, _hoisted_7))
                    }), 128))
                  ]))
                : _createCommentVNode("", true)
            ])
          ])
        ])
      ]),
      _createElementVNode("div", _hoisted_8, [
        _createElementVNode("div", _hoisted_9, [
          _cache[7] || (_cache[7] = _createElementVNode("h6", { class: "fs-18 mb-35 text-title fw-semibold" }, " Selected Products For Sales ", -1)),
          _createElementVNode("div", _hoisted_10, [
            _createElementVNode("table", _hoisted_11, [
              _cache[6] || (_cache[6] = _createElementVNode("thead", null, [
                _createElementVNode("tr", null, [
                  _createElementVNode("th", {
                    scope: "col",
                    class: "text-title fw-normal fs-14 pt-0 ps-0 ls-1"
                  }, " PRODUCT "),
                  _createElementVNode("th", {
                    scope: "col",
                    class: "text-title fw-normal fs-14 pt-0 ls-1"
                  }, " CODE "),
                  _createElementVNode("th", {
                    scope: "col",
                    class: "text-title fw-normal fs-14 pt-0 ls-1"
                  }, " UNIT COST "),
                  _createElementVNode("th", {
                    scope: "col",
                    class: "text-title fw-normal fs-14 pt-0 ls-1"
                  }, " STOCK "),
                  _createElementVNode("th", {
                    scope: "col",
                    class: "text-title fw-normal fs-14 pt-0 ls-1"
                  }, " QUANTITY "),
                  _createElementVNode("th", {
                    scope: "col",
                    class: "text-title fw-normal fs-14 pt-0 ls-1"
                  }, " SUBTOTAL "),
                  _createElementVNode("th", {
                    scope: "col",
                    class: "text-title fw-normal fs-14 pt-0 ls-1 text-end pe-0"
                  }, " DELETE ")
                ])
              ], -1)),
              _createElementVNode("tbody", null, [
                (_ctx.products.length === 0)
                  ? (_openBlock(), _createElementBlock("tr", _hoisted_12, _cache[5] || (_cache[5] = [
                      _createElementVNode("td", {
                        colspan: "9",
                        class: "text-center text-black fs-14"
                      }, " No products are selected yet ", -1)
                    ])))
                  : _createCommentVNode("", true),
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.products, (product) => {
                  return (_openBlock(), _createElementBlock("tr", {
                    key: product.id
                  }, [
                    _createElementVNode("td", _hoisted_13, _toDisplayString(product.name), 1),
                    _createElementVNode("td", _hoisted_14, _toDisplayString(product.barCode), 1),
                    _createElementVNode("td", _hoisted_15, " HTG " + _toDisplayString(product.price), 1),
                    _createElementVNode("td", _hoisted_16, [
                      _createElementVNode("span", _hoisted_17, _toDisplayString(product.quantity), 1)
                    ]),
                    _createElementVNode("td", _hoisted_18, [
                      _createElementVNode("div", _hoisted_19, [
                        _createElementVNode("button", {
                          class: "plusBtn",
                          onClick: ($event: any) => (_ctx.decrement(product))
                        }, null, 8, _hoisted_20),
                        _withDirectives(_createElementVNode("input", {
                          type: "text",
                          size: "25",
                          "onUpdate:modelValue": ($event: any) => ((product.salesQuantity) = $event),
                          max: product.quantity,
                          class: "count",
                          onChange: ($event: any) => (_ctx.onQuantityChange(product))
                        }, null, 40, _hoisted_21), [
                          [
                            _vModelText,
                            product.salesQuantity,
                            void 0,
                            { number: true }
                          ]
                        ]),
                        _createElementVNode("button", {
                          class: "minusBtn",
                          onClick: ($event: any) => (_ctx.increment(product))
                        }, null, 8, _hoisted_22)
                      ])
                    ]),
                    _createElementVNode("td", _hoisted_23, " HTG " + _toDisplayString(_ctx.formatNumber(product.salesQuantity * product.price)), 1),
                    _createElementVNode("td", _hoisted_24, [
                      _createElementVNode("div", _hoisted_25, [
                        _createElementVNode("a", _hoisted_26, [
                          _createElementVNode("img", {
                            src: _imports_1,
                            alt: "Close Icon",
                            onClick: ($event: any) => (_ctx.deleteProduct(product))
                          }, null, 8, _hoisted_27)
                        ])
                      ])
                    ])
                  ]))
                }), 128))
              ])
            ])
          ])
        ])
      ]),
      (_ctx.products.length > 0)
        ? (_openBlock(), _createBlock(_component_SubmitPurchase, {
            key: 0,
            totalCost: _ctx.totalCost,
            products: _ctx.products
          }, null, 8, ["totalCost", "products"]))
        : _createCommentVNode("", true),
      _cache[8] || (_cache[8] = _createElementVNode("div", { class: "flex-grow-1" }, null, -1)),
      _createVNode(_component_MainFooter)
    ]),
    _cache[9] || (_cache[9] = _createStaticVNode("<div class=\"delete-popup offcanvas offcanvas-end border-0\" tabindex=\"-1\" id=\"deletePopup\" data-v-225ee920><div class=\"offcanvas-body p-0\" data-v-225ee920><div class=\"delete-success\" data-v-225ee920><img src=\"" + _imports_2 + "\" alt=\"Tick Icon\" data-v-225ee920><span class=\"text-white fw-medium\" data-v-225ee920> Your product is deleted from the list. </span></div></div></div>", 1))
  ], 64))
}